export default __webpack_public_path__ + "static/media/Shadowy_Super_Coder-IAMA.535bb2e0.png";